import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass/styled-components';
import { DataTable } from '@getro/rombo';
import { useAdminData } from './hooks/useAdminData';

export const AdminDataTable = ({
  admins,
  onRemoveAdmin,
  onResendInvitation,
  onUpdateRole,
  isResendingInvitation,
  userToResendInvitation,
  emptyView,
  hasActiveFilters,
}) => {
  const { columns, rows } = useAdminData({
    admins,
    onRemoveAdmin,
    onResendInvitation,
    onUpdateRole,
    isResendingInvitation,
    userToResendInvitation,
    hasActiveFilters,
  });

  return (
    <Flex data-testid="admin-list">
      <DataTable
        sx={{
          pb: 3,
          minWidth: '720px',
          height: ['600px', '500px', '100%'],
          width: ['100%!important', '100%!important', '1600px!important'],
          maxWidth: '1600px!important',
          flexGrow: 1,

          '[role="columnheader"]': {
            alignSelf: 'flex-end',
            justifyContent: 'flex-start',
          },
        }}
        virtuosoProps={{
          useWindowScroll: true,
        }}
        items={rows}
        columnDefinition={columns}
        emptyView={emptyView}
        isInitialized
        rowProps={({ original }) => ({
          as: 'div',
          'data-testid': `admin-${original.id}`,

          sx: {
            borderBottom: '1px solid',
            borderColor: 'border.subtle',
            '& > div > div': {
              display: 'flex',
              alignItems: 'center',
            },
            ':hover': {
              backgroundColor: 'neutral.20',
            },
          },
        })}
      />
    </Flex>
  );
};

AdminDataTable.propTypes = {
  admins: PropTypes.array,
  onRemoveAdmin: PropTypes.func,
  onResendInvitation: PropTypes.func.isRequired,
  onUpdateRole: PropTypes.func,
  isResendingInvitation: PropTypes.bool,
  userToResendInvitation: PropTypes.object,
  emptyView: PropTypes.node,
  hasActiveFilters: PropTypes.bool,
};

AdminDataTable.defaultProps = {
  admins: [],
  onRemoveAdmin: null,
  onUpdateRole: null,
  isResendingInvitation: false,
  userToResendInvitation: null,
  emptyView: null,
  hasActiveFilters: false,
};
